export const API = {
    // Clients and authorization
    GetProfile: () => 'auth/profile',
    GetClient: () => `client`,
    UpdateClient: () => `client/update`,
    GetAuthenticatedUploadSignature: () =>
        `playlist/authenticated-upload-signature`,
    GetAllUsers: () => 'users/all',
    DeleteUser: () => `users/delete`,
    UpdateUser: () => `users`,

    GetAvailableClients: () => 'users/available-clients',

    GetAllVideos: () => `video/all`,
    GetAuthenticatedUploadURL: () => `video/authenticated-url`,
    CreateVideo: () => `video/create`,
    GetVideo: (videoHash: string) => `video/${videoHash}`,
    DeleteVideo: (videoHash: string) => `video/${videoHash}/delete`,
    UpdateVideo: (videoHash: string) => `video/${videoHash}/update`,

    GetAllPlaylists: () => `playlist/all`,
    GetPlaylist: (playlistHash: string) => `playlist/${playlistHash}`,
    GetLandingPagePlaylist: (playlistHash: string) =>
        `playlist/lp-playlist/${playlistHash}`,
    CreatePlaylist: () => `playlist/create`,
    UpdatePlaylist: (playlistHash: string) => `playlist/${playlistHash}/update`,

    GetAllCollections: () => 'collection/all',
    GetCollection: (collectionHash: string) => `collection/${collectionHash}`,
    CreateCollection: () => `collection/create`,
    UpdateCollection: (collectionHash: string) =>
        `collection/${collectionHash}/update`,
    DeleteCollection: (collectionHash: string) =>
        `collection/${collectionHash}/delete`,

    // Landing Pages
    GetAllLandingPages: () => `landingpage`,
    GetLandingPage: (landingPageHash: string) =>
        `landingpage/${landingPageHash}`,
    GetCrowLinksByLandingPage: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/crowlink`,
    CreateLandingPage: () => `landingpage/create`,
    DuplicateLandingPage: () => `landingpage/duplicate`,
    UpdateLandingPageContent: () => `landingpage/update-content`,
    UpdateLandingPage: () => `landingpage/update`,
    UpdateLandingPageLinks: () => `landingpage/update-links`,
    UpdateLandingPageCartUpsells: () => `landingpage/update-cart-upsells`,

    // Landing Page Templates
    GetAllLandingPageTemplates: () => `landingpage-template`,
    GetTemplatesRankedByAi: () => `landingpage-template/ai-ranked`,
    GetTemplatePreview: (landingPageHash: string) =>
        `landingpage-template/preview/${landingPageHash}`,

    // Images
    UploadImages: () => `landingpage/upload-images`,

    // Landing Page Links
    GetAllLandingPageLinks: () => `landingpagelink/all`,
    GetLandingPageLink: (landingPageLinkHash: string) =>
        `landingpagelink/${landingPageLinkHash}`,
    UpdateLandingPageLinkContent: () => `landingpagelink/update-content`,
    UpdateLandingPageLinkMetadata: () => `landingpagelink/update-metadata`,
    GetAllUnimportedShopifyProducts: () =>
        `landingpagelink/unimported-shopify-products`,
    GetAllShopifyProducts: () => `landingpagelink/all-shopify-products`,
    GetAllProductsOrderedByRelevanceToMetaAd: (metaAdId: string) =>
        `landingpagelink/all-products-ordered-by-relevance-to-meta-ad/${metaAdId}`,
    GetShopifyProductById: (shopifyId: string) =>
        `landingpagelink/shopify-product/${shopifyId}`,
    ImportShopifyProduct: () => `landingpagelink/import-shopify-product`,
    ResyncImagesForLandingPageLink: () => `landingpagelink/resync-images`,
    UploadReviewsCsvCreateURL: () =>
        `landingpagelink/upload-reviews-csv/create-upload-url`,
    ProcessReviewsCsv: () => `landingpagelink/upload-reviews-csv/process-file`,

    // Storefronts Generator
    GenerateLandingPageFromTemplate: () =>
        `storefronts-generator/generate-from-template`,
    AiGenerateFromTemplate: () =>
        `storefronts-generator/ai-generate-from-template`,
    RetryAiGenerateFromTemplate: (landingPageHash: string) =>
        `storefronts-generator/ai-generate-from-template/${landingPageHash}`,

    // Analytics
    GetExploCustomerToken: () => `explo/token`,
    GetFullFunnelAggregations: () => 'metrics/full-funnel-aggregations',
    GetStorefrontMetrics: () => `metrics/storefront-metrics`,
    GetPerformanceInsights: () => 'performance-insights',
    GetStorefrontComparison: () => 'storefront-comparison',

    // Crow Links
    GetAllCrowLinks: () => 'crowlink',
    CreateCrowLink: () => 'crowlink/create',
    UpdateCrowLink: (linkHash: string) => `crowlink/${linkHash}`,
    GetRecentCrowLinkTestData: (linkHash: string, experimentId: string) =>
        `crowlink/${linkHash}/experiment/${experimentId}/recent-test-data`,

    // Personas
    GetAllPersonas: () => 'personas',
    CreatePersona: () => 'personas/create',
    UpdatePersona: (id: number) => `personas/${id}`,
    DeletePersona: (id: number) => `personas/${id}`,
    QueuePersonaGeneration: () => 'personas/queue-generation',
    PersonaGenerationStatus: () => 'personas/generation-status',
    GetPersonasRankedByAd: (adId: string) => `personas/ai-ranked-by-ad/${adId}`,
    // Meta Ads
    GetMetaAds: () => 'meta-ads',

    // Client Settings
    UpdateGoogleFontFamily: () => 'client/settings/google-font-family',
    GetClientSettings: () => 'client/settings',
    SearchGoogleFonts: () => 'client/settings/google-fonts',
    UpdateClientSettings: () => 'client/settings',

    // Brand Guidelines
    CreateBrandGuideline: () => 'client/settings/brand-guideline',
    UpdateBrandGuideline: (id: number) =>
        `client/settings/brand-guideline/${id}`,
    DeleteBrandGuideline: (id: number) =>
        `client/settings/brand-guideline/${id}`,

    // Brand Benefits
    BulkReplaceBrandBenefits: () => 'brand-benefit/bulk',

    // App install urls
    GetFacebookAppInstallUrl: () => 'client/facebook/app-install-url',

    // Slack
    GetSlackChannelInvite: () => 'slack/channel',
}
